import { type SegmentEvent } from 'src/types/segment';
import { fetchWithRetry } from 'src/utils/fetch-with-retry';
import { v4 as uuidv4 } from 'uuid';

const createMessageId = () => `ajs-next-${Date.now()}-${uuidv4()}`;

export const sendSegmentEvent = async (
  event: string,
  entityId: string | null,
  properties: Omit<SegmentEvent, 'event'>
) => {
  if (!process.env.SEGMENT_HOST || !process.env.SEGMENT_KEY) {
    // eslint-disable-next-line no-console
    console.error('Segment configuration is missing');
    return;
  }

  const context = {
    userAgent: navigator.userAgent,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: navigator.language,
    page: {
      title: document.title,
      url: window.location.href,
      referrer: document.referrer,
    },
  };

  try {
    await fetchWithRetry({
      url: `https://${process.env.SEGMENT_HOST}/t`,
      options: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        keepalive: true,
        body: JSON.stringify({
          anonymousId: entityId,
          type: 'track',
          event,
          writeKey: process.env.SEGMENT_KEY,
          properties,
          sentAt: new Date().toISOString(),
          timestamp: new Date().toISOString(),
          context,
          messageId: createMessageId(),
        }),
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to send segment event:', error);
  }
};
